@if (inited) {
  <sm-tab-view class="height100p full-height">
    <sm-tab header="Neue Abmeldung">
    <div class="height100p">
        <div class="center flex-col align-items-start">
        <sm-form  class="width100p" [form]="form">
        </sm-form>
        <p-button icon="fas fa-play" label="Ablegen" (onClick)="addSickNote()"></p-button>
        </div>
    </div>
    </sm-tab>
    @if (id != null) {
    <sm-tab header="Abmeldungen verwalten">
        <sm-table class="height100p" [data]="table" [allowRemoveRow]="isAdmin" (onRowRemoved)="deleteSickNote($event)" (onCellClicked)="sickNoteClicked($event)">
        </sm-table>
    </sm-tab>
    }
  </sm-tab-view>
}
